import React from 'react';

export const CodeBlock = React.lazy(() => import('./CodeBlock'));
export const CodeInline = React.lazy(() => import('./CodeInline'));
